exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-profile[data-v-0decc5da] {\n  cursor: pointer;\n}", ""]);

// exports
